/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener('variant:changed', function (event) {
    var variant = event.detail.variant; // Gives you access to the whole variant details
    const variantMetafieldDataElement = document.getElementById('variant_metafield_data');
    if (variantMetafieldDataElement) {
        // Parse the JSON containing all variants' metafield data
        const allVariantMetafieldData = JSON.parse(variantMetafieldDataElement.textContent || '{}');
        // Retrieve the specific metafield data for the changed variant
        const variantData = allVariantMetafieldData[variant.id.toString()];

        if (variantData) {
            // Iterate through the variant data to update corresponding elements
            Object.keys(variantData).forEach(key => {
                if (variantData[key]) {

                    // Select all <p> elements with class "characteristics-" + key
                    const selector = `.characteristics-${key} .value`;
                    const elements = document.querySelectorAll(selector);

                    elements.forEach(element => {
                        // Update each element's content. Adjust the formatting as needed.
                        // This will replace the content inside the <p> tag, you may adjust as needed
                        element.innerHTML = `${variantData[key]}`;
                    });
                }
            });
            if(variantData['minimum_quantity']) {
                document.querySelectorAll('.product-meta__pack').forEach(element => {
                    element.innerHTML = `${variantData['minimum_quantity']}`;
                });
                document.querySelectorAll('.product-form__info-content .price-minimum-quantity span').forEach(element => {
                    element.innerHTML = `${variantData['unit_price']}`;
                });
            }
        }
    }
});

